import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { ConversationService } from '../services/conversation.service';
import { Router } from '@angular/router';
import { SpeechRecognitionService } from '../services/speech-recognition.service';
import { InputService } from '../services/input.service';

@Component({
  selector: 'app-inputbar',
  templateUrl: './inputbar.component.html',
  styleUrls: ['./inputbar.component.css']
})
export class InputbarComponent implements OnInit {
  @Input() keyword:string = '';
  @Input() profileView: boolean = false;
  @Input() setPlaceholder: string;
  @Input() set setComponentId(id:string){ this.componentId = id;}
  @Input() isCard:boolean = false;
  @Output() idOutput = new EventEmitter<string>();

  @ViewChild('text') public face:ElementRef;
  
  isBusy:boolean = false;
  speechApi: boolean = true;
  speechData: string;
  selectedValue = 'Current';
  componentId:string;

  @Input() searchGlobal:boolean = false;

  constructor(private conversationService: ConversationService, private router: Router, private speechRecognitionService:SpeechRecognitionService, private inputService:InputService) { 
  }

  ngOnInit() {
    this.face.nativeElement.focus();
  }

  changeView(view){
    this.selectedValue = view;
  }

  searchByKeyword(keyword:string){
    if(keyword.trim()){
      this.isBusy = true;
      setTimeout(() => {
        this.isBusy = false;
      }, 1500);
      this.keyword = keyword;
      
      this.inputService.changeInputValue(this.componentId, keyword).subscribe(result=>{
        if(result == "1"){
          this.inputService.executeInputWorkflow(this.componentId).subscribe(wfResult =>{
            this.idOutput.emit(wfResult);
          });
        }
      });
    }
  }

  searchAll(value:string){
    this.isBusy = true;
    this.conversationService.converse(value).subscribe(result=> {
      var resultObject = JSON.parse(result);
      this.isBusy = false;
        if(resultObject.ReturnType == "0"){
          if(resultObject.Arguments){
            var path = [];
            resultObject.Arguments.forEach(element => {
              path.push(element);
            });;
            this.router.navigate(path);
          }
        }
    });
  }

}